module.exports = __webpack_public_path__ + "img/dardo-no-centro-de-alvo.jpg";